

export const ROUTES = {
  HOME: '/',
  PLANNING: '/Planning',
  CHRONOGRAM: '/Chronogram',
  IMAGE: '/Image',
  CHART: '/Chart',
  SETTING: '/Setting',
  TIMEGRID: '/Timegrid',
};